import { render, staticRenderFns } from "./carousel-item.vue?vue&type=template&id=37e3da1c"
import script from "./carousel-item.vue?vue&type=script&lang=js"
export * from "./carousel-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports